import { lazy } from 'react'
import { Route } from 'commons/types/route'
import { CREATE_PARTICIPATION, LIST_PARTICIPATION, UPDATE_PARTICIPATION } from 'commons/constants/permissions'

const ParticipationListPage = lazy(() => import('pages/Participation/List'))
const ParticipationCreatePage = lazy(() => import('pages/Participation/Create'))
const ParticipationWithConflict = lazy(() => import('pages/Participation/Conflict'))

export default [
  {
    path: '/participations',
    component: ParticipationListPage,
    permissions: LIST_PARTICIPATION,
  },
  {
    path: '/participations/create',
    component: ParticipationCreatePage,
    permissions: CREATE_PARTICIPATION,
  },
  {
    path: '/participations/update/:participationId',
    component: ParticipationCreatePage,
    permissions: UPDATE_PARTICIPATION,
  },
  {
    path: '/participations/conflict/:participationId',
    component: ParticipationWithConflict,
    permissions: LIST_PARTICIPATION,
  },
] as Route[]
